import { render, staticRenderFns } from "./fixed-lines.vue?vue&type=template&id=2f0210bf&"
import script from "./fixed-lines.vue?vue&type=script&lang=js&"
export * from "./fixed-lines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports